import { type PageTabsItem } from '../ui/page-tabs/types'

export const CASE_UPDATES_TAB_ITEMS: PageTabsItem[] = [
  {
    label: 'Case Update History',
    value: 'case-update-history',
    to: '/dashboard/case-updates/case-update-history',
  },
  {
    label: 'Case Activity History',
    value: 'case-activity-history',
    to: '/dashboard/case-updates/case-activity-history',
  },
]

export const DOM_ID = {
  caseUpdatesPaginationPortal: 'case-updates-pagination-portal-root',
}
